<template>
    <div class="content">
        <div id="unit-area-map" ref="AreaMap"></div>
        <div id="unit-area-bar" ref="AreaBar"></div>
    </div>
</template>

<script>
    import options from './../../../../utils/options'
    import echarts from 'echarts'
    import('./../../../../assets/js/importMap');


    export default {
        name: "Areasv2",
        props: ['AreaData', 'selectArea'],

        data() {
            return {
                chartMap: '',
                chartBar: '',
                optionMap: options.optionMap,
                optionBar: options.optionBar,
                dataInfo: [],
                clickCity: '',
                provinceList: [
                    '广东', '广西', '海南', '云南', '贵州', '湖南', '福建', '江西', '浙江', '安徽', '江苏', '湖北', '河南',
                    '上海', '山东', '河北', '山西', '天津', '北京', '辽宁', '吉林', '黑龙江', '内蒙古', '新疆', '甘肃', '宁夏',
                    '陕西', '重庆', '四川', '青海', '西藏'],
            }
        },

        methods: {
            chartInit() {
                this.chartMap = echarts.init(this.$refs.AreaMap);
                this.chartBar = echarts.init(this.$refs.AreaBar);
                this.chartMap.showLoading();
                this.chartBar.showLoading();
            },

            barLoading() {
                this.optionBar.yAxis.data = this.dataInfo.yAxis;
                this.optionBar.legend.data = ['有业绩', '无业绩'];
                this.optionBar.series[0].name = '有业绩';
                this.optionBar.series[0].data = this.dataInfo.achievement_data;
                this.optionBar.series[1].name = '无业绩';
                this.optionBar.series[1].data = this.dataInfo.no_achievement_data;
                this.optionBar.series[2].data = this.dataInfo.allCount;
                this.optionBar.dataZoom[0].end = 16 * 100 / this.dataInfo.yAxis.length;
                if (this.selectArea && this.selectArea !== '全国') {
                    this.optionBar.title.text = this.selectArea + '编制单位情况'
                } else {
                    this.optionBar.title.text = '各省编制单位情况'
                }
                this.chartBar.hideLoading();
                this.chartBar.setOption(this.optionBar, true);
                this.chartBar.on('legendselectchanged', this.legendSelect)
            },

            mapLoading() {
                if (this.selectArea !== '全国') {
                    this.optionMap.geo.map = this.selectArea
                } else {
                    this.optionMap.geo.map = 'china'
                }
                if (this.selectArea === '湖北') {
                    this.optionMap.visualMap[0].left = 80;
                    this.optionMap.visualMap[0].bottom = '50%'

                } else if (this.selectArea === '内蒙古'){
                    this.optionMap.visualMap[0].left = 80;
                    this.optionMap.visualMap[0].bottom = '50%'

                } else if (this.selectArea === '青海'){
                    this.optionMap.visualMap[0].left = '90%';
                    this.optionMap.visualMap[0].bottom = 120

                } else if (['广东', '山东', '新疆'].indexOf(this.selectArea) !== -1) {
                    this.optionMap.visualMap[0].left = '80%';
                    this.optionMap.visualMap[0].bottom = 120

                } else{
                    this.optionMap.visualMap[0].left = 80;
                    this.optionMap.visualMap[0].bottom = 120
                }
                this.optionMap.series[0].name = '编制单位数量';
                this.optionMap.series[0].data = this.dataInfo.mergeData;
                this.optionMap.visualMap[0].pieces = options.setPieces(this.dataInfo.mergeData);
                this.chartMap.hideLoading();
                this.chartMap.setOption(this.optionMap, true);
                this.chartMap.on('click', this.mapClick)
            },

            mapClick(param) {
                //防止地图继续下钻，若需要继续下钻可以注释掉，敲黑板，此处是同一个元素，不是冒泡，
                if (!(this.provinceList.indexOf(param.name) === -1)) {
                    this.clickCity = param.name;
                }
            },

            postClickCity(val){
                this.$emit('postClickCity', val)
            },

            legendSelect(params) {
                if (params.selected['有业绩'] && params.selected['无业绩']) {
                    this.optionMap.series[0].name = '编制单位数量';
                    this.optionMap.series[0].data = this.dataInfo.mergeData;
                    this.optionMap.visualMap[0].pieces = options.setPieces(this.dataInfo.mergeData)
                } else if (params.selected['有业绩'] && !params.selected['无业绩']) {
                    this.optionMap.series[0].name = '有业绩单位数量';
                    this.optionMap.series[0].data = this.dataInfo.achievement_data;
                    this.optionMap.visualMap[0].pieces = options.setPieces(this.dataInfo.achievement_data);
                    this.optionBar.series[2].data = this.dataInfo.allCount
                } else if (!params.selected['有业绩'] && params.selected['无业绩']) {
                    this.optionMap.series[0].name = '无业绩单位数量';
                    this.optionMap.series[0].data = this.dataInfo.no_achievement_data;
                    this.optionMap.visualMap[0].pieces = options.setPieces(this.dataInfo.no_achievement_data)
                } else {
                    this.optionMap.series[0].data = []
                }
                this.chartMap.setOption(this.optionMap, true);
            },

            formatDate(val) {
                let areaMap = options.areaMap
                let allCount = [
                    {'name': '有业绩', 'value': val['sum_youyeji']},
                    {'name': '无业绩', 'value': val['sum_wuyeji']}];
                let Data1 = [];
                let Data2 = [];
                let y1 = [];
                let mergeCount = {};
                for (let value of val['有业绩']) {
                    if (value.name) {
                        Data1.push(value);
                        if (value.name in mergeCount) {
                            mergeCount[value.name] += value.value
                        } else {
                            mergeCount[value.name] = value.value
                        }
                    }
                }

                for (let value of val['无业绩']) {
                    if (value.name) {
                        Data2.push(value);
                        if (value.name in mergeCount) {
                            mergeCount[value.name] += value.value
                        } else {
                            mergeCount[value.name] = value.value
                        }
                    }
                }

                let mergeData = [];
                for (let i in mergeCount) {
                    mergeData.push({'name': i, 'value': mergeCount[i]})
                }
                mergeData.sort((a, b) => b.value - a.value)

                for (let i in mergeData) {
                    y1.push(mergeData[i].name)
                }

                let achievement_data = [];
                let no_achievement_data = [];
                let yAxis = [];
                for (let i in y1) {
                    let cityName = y1[i];
                    for (let value of Data1) {
                        if (y1[i] === value.name) {
                            achievement_data.push(value)
                        }
                    }
                    for (let value of Data2) {
                        if (y1[i] === value.name) {
                            no_achievement_data.push(value)
                        }
                    }
                    if (cityName.length > 5) {
                        cityName = areaMap[cityName]
                    }
                    if (i.length === 1) {
                        yAxis.push('0' + i + cityName);
                    } else {
                        yAxis.push(i + cityName);
                    }
                }
                return {mergeData, allCount, achievement_data, no_achievement_data, yAxis}
            },
        },

        watch: {
            selectArea() {
                this.chartMap.showLoading();
                this.chartBar.showLoading();
            },
            AreaData: {
                handler(val) {
                    this.dataInfo = this.formatDate(val);
                    this.barLoading();
                    this.mapLoading();
                },
                deep: true,
            },
            clickCity(val) {
                this.postClickCity(val)
            },
        },
        mounted() {
            this.chartInit();
        }
    }

</script>

<style scoped>
    .content {

        height: 100vh;
        width: 1640px;
        /*background-color: #71a4d1;*/
        /*display: block;*/
    }

    #unit-area-map {
        width: 70%;
        height: 90vh;
        float: left;
        /*margin-left: 400px;*/
        /*margin-top: 30px;*/
        padding-top: 120px;
        /*background-color: #f7f7f7;*/
    }

    #unit-area-bar {
        width: 30%;
        height: 90vh;
        float: right;
        /*margin-right: 30px;*/
        /*margin-top: 30px;*/
        padding-top: 120px;
        /*background-color: #f7f7f7;*/
    }

    .skip-top {
        font-size: 20px;
        width: 80px;
        height: 40px;
        position: absolute;
        top: 150px;
        left: 180px;
        z-index: 10;
        cursor: pointer;
    }

    .skip-province {
        font-size: 20px;
        width: 100px;
        height: 40px;
        position: absolute;
        top: 150px;
        left: 224px;
        z-index: 10;
        cursor: pointer;
    }
</style>